import { queryCache } from 'hooks/queryCache'

const Session = (state = {}, action) => {
  switch (action.type) {
    case 'LOGIN':
      queryCache.clear()
      return {
        ...state,
        ...action.data
      }
    case 'LOGOUT':
      queryCache.clear()
      return {}
    default:
      return {
        ...state
      }
  }
}

export default Session
